import { useCallback } from "react";
import { Card } from "shared/components/Card";
import { Unit } from "types/landlord/address";
import { UnitCardBody } from "./UnitCardBody";
import { UnitCardPhoto } from "./UnitCardPhoto";
import { unitDetailsPath } from "shared/app/UnitsTableView/constants";

export const UnitCard = ({
  unit,
  onActivityClick,
  visibleFields,
  fromListings
}: {
  unit: Unit;
  onActivityClick: (unit: Unit) => void;
  visibleFields: Set<string>;
  fromListings?: boolean;
}) => {
  const shows = useCallback(
    (field: string) => visibleFields.has(field),
    [visibleFields]
  );

  return (
    <Card
      linkTo={unitDetailsPath(unit.property?.id, unit.id, { fromListings })}
      className="overflow-hidden"
    >
      <UnitCardPhoto
        unit={unit}
        shows={shows}
        onActivityClick={onActivityClick}
      />
      <UnitCardBody unit={unit} shows={shows} />
    </Card>
  );
};
